var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.28125C7.05178 2.28125 7.09375 2.23928 7.09375 2.1875C7.09375 2.13572 7.05178 2.09375 7 2.09375C6.94822 2.09375 6.90625 2.13572 6.90625 2.1875C6.90625 2.23928 6.94822 2.28125 7 2.28125ZM5.59375 2.1875C5.59375 1.41085 6.22335 0.78125 7 0.78125C7.77665 0.78125 8.40625 1.41085 8.40625 2.1875C8.40625 2.96415 7.77665 3.59375 7 3.59375C6.22335 3.59375 5.59375 2.96415 5.59375 2.1875ZM7 7.09375C7.05178 7.09375 7.09375 7.05178 7.09375 7C7.09375 6.94822 7.05178 6.90625 7 6.90625C6.94822 6.90625 6.90625 6.94822 6.90625 7C6.90625 7.05178 6.94822 7.09375 7 7.09375ZM5.59375 7C5.59375 6.22335 6.22335 5.59375 7 5.59375C7.77665 5.59375 8.40625 6.22335 8.40625 7C8.40625 7.77665 7.77665 8.40625 7 8.40625C6.22335 8.40625 5.59375 7.77665 5.59375 7ZM7.09375 11.8125C7.09375 11.8643 7.05178 11.9062 7 11.9062C6.94822 11.9062 6.90625 11.8643 6.90625 11.8125C6.90625 11.7607 6.94822 11.7188 7 11.7188C7.05178 11.7188 7.09375 11.7607 7.09375 11.8125ZM7 10.4062C6.22335 10.4062 5.59375 11.0358 5.59375 11.8125C5.59375 12.5892 6.22335 13.2188 7 13.2188C7.77665 13.2188 8.40625 12.5892 8.40625 11.8125C8.40625 11.0358 7.77665 10.4062 7 10.4062Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDots);
export default __webpack_public_path__ + "static/media/expand_dots.42ce1542db46bc26c011d60268b83629.svg";
export { ForwardRef as ReactComponent };